module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://twitter.com/LowcoTV",
      "title": "Twitter",
      "target": "_blank",
      "rel": "noopener",
      "aria-label": "external link: twitter"
    }
  }, [_c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "twitter",
      "scale": _vm.iconSize
    }
  })], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://discord.gg/Lowco",
      "title": "Discord",
      "target": "_blank",
      "rel": "noopener",
      "aria-label": "external link: discord"
    }
  }, [_c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "discord",
      "scale": _vm.iconSize
    }
  })], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/user/Lowco2525",
      "title": "Youtube",
      "target": "_blank",
      "rel": "noopener",
      "aria-label": "external link: youtube"
    }
  }, [_c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "youtube",
      "scale": _vm.iconSize
    }
  })], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/lowco2525/",
      "title": "Instagram",
      "target": "_blank",
      "rel": "noopener",
      "aria-label": "external link: instagram"
    }
  }, [_c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "instagram",
      "scale": _vm.iconSize
    }
  })], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.twitch.tv/lowco",
      "title": "Twitch",
      "target": "_blank",
      "rel": "noopener",
      "aria-label": "external link: twitch"
    }
  }, [_c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "twitch",
      "scale": _vm.iconSize
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01084a90","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/SocialMediaIcons.vue
// module id = 1032
// module chunks = 2 5 6 8